import { Node } from "../../components/RichText/RichText";

export default interface IAcordeon {
    title: string;
    content: string;
}

export const contentWithOutTranscript = (node: Node[]): Node[] | undefined => {
  let transcriptPositionUl = 0;
    
  node?.every((elem, index) => {
    transcriptPositionUl = index;
    
    if( elem.type === "p" && elem.children && elem.children[0].text?.includes("Transcript [")) {
      return false;
    } 
    
    return true;
  });

  if(transcriptPositionUl > 0 && transcriptPositionUl !== (node.length - 1)){
    return node.splice(0, transcriptPositionUl);
  }   

  return node;
}

export const transcript = (node: Node[]): IAcordeon[] | undefined => {
    let transcriptPositionUl = 0;
    let transcriptPositionP = 0;
    
    const searchTranscriptUl = (nodes?: Node[]): Node | undefined =>
      nodes?.find((elem, index) => {
        transcriptPositionUl = index;
        return (
          elem.type === "p" &&
          elem.children &&
          (elem.children[0].text?.includes("Transcript [") ||
          elem.children[0].text?.includes("Transcription ["))
        );
      });
    
      const searchTranscriptP = (nodes?: Node[]): Node | undefined =>
      nodes?.find((elem) => elem.text?.includes("Transcript [") || elem.text?.includes("Transcription ["));

    const hasTranscriptUl = node.find(
      (item) => item.type === "ul" && searchTranscriptUl(item.children)
    );
    
    const hasTranscriptP = node.find((item, index) => {
      transcriptPositionP = index;
      return item.type === "p" && searchTranscriptP(item.children);
    });
    
    let newList: Node[] | undefined;
    
    if (hasTranscriptUl) {
      newList = hasTranscriptUl.children?.slice(transcriptPositionUl + 1);
    } else if (hasTranscriptP) {
      newList = node?.slice(transcriptPositionP + 1);
    }

    return newList?.map((item) => {
      const title =
        item.children &&
        (item.children.length > 1
          ? item.children[0]?.text
          : item.children[0].text?.split("]")[0] + "]");
      const content =
        item.children &&
        (item.children.length > 1
          ? item.children[1]?.text
          : item.children[0].text?.split("]")[1]?.replace(/^\:+|/gm, ""));
      return {
        title: title,
        content: content,
      } as IAcordeon;
    });
};